export const iosAppDownloadUrls = {
  kr: process.env.REACT_APP_IOS_APP_KR_DOWNLOAD_URL,
  jp: process.env.REACT_APP_IOS_APP_JP_DOWNLOAD_URL,
};
export const androidAppDownloadUrls = {
  kr: process.env.REACT_APP_ANDROID_APP_KR_DOWNLOAD_URL,
  jp: process.env.REACT_APP_ANDROID_APP_JP_DOWNLOAD_URL,
};
